import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getLanguage, setLanguage } from '../../../src/tools/getUserInfo';
//import { languageDict } from '../../index';

const defaultLang = getLanguage();

//const systemLang = navigator.language.split('-')[0];
const lang = 'en-AU'; // languageDict[systemLang || ''] ||

if (!defaultLang) {
  setLanguage(lang);
}
const defaultState = {
  lang: defaultLang || lang,
};

const storeLangSlice = createSlice({
  name: 'storeLang',
  initialState: defaultState,
  reducers: {
    changLang: (state, action) => {
      const { lang } = action.payload;

      if (lang != state.lang) {
        setLanguage(lang);
      }
      state.lang = lang;
    },
  },
});
export const { changLang } = storeLangSlice.actions;
//
export default storeLangSlice.reducer;

export const getLang = () => {
  return createSelector([(state: any) => state.language.lang], (lang) => {
    return lang;
  });
};
